_ = require 'underscore'
CustomFieldBadgeView = require 'app/scripts/views/custom-field/custom-field-badge-view'
{ trackUe } = require '@trello/analytics'
xtend = require 'xtend'

CUSTOM_FIELDS_ID = require('@trello/config').customFieldsId

module.exports = class CustomFieldCardDetailBadgeView extends CustomFieldBadgeView
  tagName: 'div'
  className: -> 'custom-field-detail-item'

  getBadgeIcon: ->
    @customField.icon()

  getBadgeText: ->
    @customFieldItem?.getFrontBadgeText() ? ''

  track: ->
    trackUe('card detail', 'opens', 'Power-Up', '', '', 'card-detail-badge', CUSTOM_FIELDS_ID)
    @options.sendPluginUIEvent({
      idPlugin: CUSTOM_FIELDS_ID
      idBoard: @model.getBoard().id
      idCard: @model.id
      event:
        action: 'clicked'
        actionSubject: 'badge'
        actionSubjectId: 'cardDetailBadge'
        source: 'cardDetailScreen'
    })

  renderBadge: (badge) ->
    @$el.html(@template(badge))
    @$('.js-custom-field-detail-badge')

  render: ->
    customField = @customField.toJSON()
    customFieldItem = @customFieldItem?.toJSON()
    badgeData = _.pick customField, 'name', 'type', 'options'
    badgeData.idCustomField = customField.id
    if customFieldItem
      badgeData.idCustomFieldItem = customFieldItem.id
      badgeData.idValue = customFieldItem.idValue
    badgeData.editable = @model.editable()

    text = @getBadgeText()
    icon = @getBadgeIcon()

    editable = @model.editable()
    colorClass = @getColorClass()
    color = if colorClass then ".field-color.#{colorClass}" else ''

    badgeData = xtend badgeData, { icon, text, editable, color }

    $badge = @renderBadge(badgeData)

    @
